import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import HeaderSubText from './header-sub-text'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useIsMobile from 'components/program-marketing/useIsMobile'
import { JRL_REGISTRATION_WITH_CODE } from 'lib/junior-league-utils/constants'

const useStyles = makeStyles(theme => ({
  accessCode: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    border: '1px solid #FFFFFF',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '8px 18px',
    color: theme.palette.primary.contrastText,
    marginBottom: '16px',
    display: 'inline-block',
  },
  headerSectionBg: {
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.primary.contrastText,
    paddingTop: '86px',
  },
}))

const getDivisionText = {
  JRL_13U(minAge, maxAge) {
    if (minAge && maxAge) {
      return `13U (ages ${minAge}-${maxAge})`
    }
    return '13U (ages 13 and younger)'
  },
  JRL_17U(minAge, maxAge) {
    if (minAge && maxAge) {
      return `17U (ages ${minAge}-${maxAge})`
    }
    return '17U (ages 14-17)'
  },
}

export const HeaderSection = ({ program, scheduleLabel }) => {
  const isMobile = useIsMobile()
  const classes = useStyles()

  return (
    <Box
      px={isMobile ? 0 : 4}
      pt={isMobile ? 2 : 4}
      pb={isMobile ? 12 : 4}
      className={classes.headerSectionBg}
    >
      <Box mx={isMobile ? 2 : 12} my={10}>
        <Grid container>
          <Grid item sm={12} md={8}>
            {JRL_REGISTRATION_WITH_CODE[program.registrationStatus] && (
              <div className={classes.accessCode}>Access Code Required</div>
            )}

            {!isMobile && <HeaderSubText>{scheduleLabel}</HeaderSubText>}

            <Typography variant="h1" align="left" gutterBottom>
              {program.name}
            </Typography>

            {isMobile && <HeaderSubText>{scheduleLabel}</HeaderSubText>}
            <HeaderSubText>
              {getDivisionText[program.division](
                program.minAge,
                program.maxAge,
              )}
            </HeaderSubText>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
